export const WEB3FORMS_ACCESS_KEY = import.meta.env.VITE_WEB3FORMS_ACCESS_KEY;
export const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';
